import { Component } from '@angular/core';

@Component({
  selector: 'app-view-index',
  templateUrl: './Index.html',
  styleUrls: ['./style.css']
})
export class AppViewIndex {

}
